import MiscService from "@/services/miscService";
import OdService from "@/services/odService";
import EventBus from "@/eventBus";
import {ALERT} from '../../constants/alert.js'
import { GET_CONVERSATIONS } from '@/constants/constantsValues.js';

// this is the vuex module for the Front Desk Workflow
export const moduleFrontDesk = {
  namespaced: true,
  state: {
    // It will Mutate according to the filter.
    left_panel_contacts: [], // it holds initial FD leftpanel contacts, filtered contacts based on Type, Tag, OD.

    fd_contacts: [], // FD left panel Contacts

    isFilterApplied : false, // it will track weather left panel contacts are filtered or not

    // the current contact selected 
    current_contact: {},

    // ---------------------------------------------
    previousContactId : 0,
    
    // current conversation with lazy loading
    allConversations: [],

    hasMoreConversatonTop : true, // it will be used to check if there are more conversations to load

    conversation_loading : false,  // lazy loading of conversation

    isScrollerVisible : false,

    hasMoreConversatonBottom : false,

    // ---------------------------------------------------

    // true if the left panel calls are loading (they are being received from the server)
    loading: true,

    allcontact_Typesdata: [],
    // flag to toggle the threadVisibility of the email modal
    threadVisibility: false,
    // the selected thread Id for an email
    thread: null,
    // the current email thread data selected
    emails: [],
    alltags_data: [],
    // OD Filter List — loaded dynamically from the backend (od_filters table).
    // Falls back to [] until loadOdFilters action completes.
    odFilterList: [],

    odData: [], // it holds the OD data for the selected filter, we kept this as array to maintain order

    odDataHash: {}, // it holds the OD data contact_id's, it will be used to find weather the contact_id is present in odData or not.
    // use case whenever we send message to od filtered contacts the conversation will be auto tagged on that time we don't want to loop through the odData to find the contact_id is in the array or not, we will use this hash.

    odSelected_value: "", // od filter applied

    selected_OD_tag: null, // maintaining the state to find which od tag_id for conversation auto tag.

    right_panel_tab: "",

    isUser: false, // selected item from default display is user or contact

    message_templates: [],
    //lab cases number 
    LabCaseNum : null,

    labmoredata :true,

    laboffset : 0,

    conversationtagoffset:0,

    odHasMore: true,

    conversationtag:[],

    showconversationtagarrow:false
  },
  getters: {
    fd_contacts(state) {
      return state.fd_contacts;
    },
    left_panel_contacts(state) {
      return state.left_panel_contacts;
    },
    current_contact(state) {
      return state.current_contact;
    },
    get_alltags_data(state) {
      return state.alltags_data;
    },
    get_AllContact_Typesdata(state) {
      return state.allcontact_Typesdata;
    },
    callsByContact(state, getters) {
      return (contact_id) => {
        return state.left_panel_contacts.filter(
          (c) => getters.contactByCall(c) === contact_id
        );
      };
    },
    getLabCaseNum(state){
      return state.LabCaseNum;
    },
    // returns the main contact_id associated with the provided call (if any)
    contactByCall() {
      return (call) => {
        // let n = call.comm_participants.find((p) => p.contact_id) || {};
        // return n.contact_id || null;
        let isContact = call.isContact;
        if (isContact) {
          let n = call.contact_id || {};
          return parseInt(n) || null;
        }
        return null;
      };
    },
    // returns the main number associated with the provided call (if any)
    numberByCall() {
      return (call) => {
        // let n =
        // call.comm_participants.find((p) => p.contact_id) ||
        // call.comm_participants.find((p) => p.phone_num && !p.user_id) ||
        // {};
        // return n.phone_num || null;
        let n = call.phone_num || call.first_name || {};
        return n || null;
      };
    },
    loading(state) {
      return state.loading;
    },
    getAllConversations(state) {
      return state.allConversations;
    },
    getThreadVisibility(state) {
      return state.threadVisibility;
    },
    getThread(state) {
      return state.thread;
    },
    getEmails(state) {
      return state.emails;
    },
    odFilterList(state) {
      return state.odFilterList;
    },
    odData(state) {
      return state.odData;
    },
    isODFilterContact: (state) => {
      return (contact_id) => {
        return state.odDataHash[contact_id] ? true : false;
      };
    },
    odFilterSelectedValue(state) {
      return state.odSelected_value;
    },
    getOdTag(state) {
      return state.selected_OD_tag;
    },
    right_panel_tab(state) {
      return state.right_panel_tab;
    },
    isUser(state) {
      return state.isUser;
    },
    message_templates(state) {
      return state.message_templates;
    },
    conversation_loading(state){
      return state.conversation_loading;
    },
    hasMoreConversatonTop(state){
      return state.hasMoreConversatonTop;
    },
    hasMoreConversatonBottom(state){
      return state.hasMoreConversatonBottom;
    },
    isScrollerVisible(state){
      return state.isScrollerVisible;
    },
    dynamicMessageThreshold(state){
      const messageHeight = 60; // Default minimum message height in pixels
      let height = document.documentElement.clientHeight;
      height = Math.ceil((height / messageHeight) * 1.3); // increase the height by 30% for scrolling
      return height;
    },
    getlabdata(state){
    return state.labmoredata;
    },
    getlaboffset(){
      return state.laboffset;
    },
    getconversationtag(state) {
      return Array.isArray(state.conversationtag)
        ? [...state.conversationtag].sort((a, b) => b.timestamp - a.timestamp)
        : [];
    },

    getshowconversationtagarrow(state) {
      return state.showconversationtagarrow;
    },
  },
  mutations: {
    addNewconversationtag(state, value){
     const matched = state.odData.find(
    c => c.contact_id === value.contact_id
  );
    if (!matched || state.conversationtag.length === 0) {
    return;
  }
  if(matched && !matched.conversationstags){
     matched.conversationstags = [];
  }
    matched.conversationstags.push(value.tags);
    state.showconversationtagarrow = true;
   
    },
    setcontactconversationtag(state, value) {
      state.conversationtag = Array.isArray(value) ? value : [value];
      state.showconversationtagarrow = true;
    },
    SetConversationTagOffset(state ,value){
        state.conversationtagoffset = value;
 },
    setshowconversationtagarrow(state, value) {
      state.showconversationtagarrow = value;
    },
    setOdHasMore(state, value) {
     state.odHasMore = value;
     },
    fd_contacts(state, value) {
      state.fd_contacts = value;
    },
    setLabCaseNum(state,value){
      state.LabCaseNum = value;
    },
    set_left_panel_contacts(state, value) {
      state.left_panel_contacts = value;
    },
    set_alltags_data(state, value) {
      state.alltags_data = value;
    },
    set_AllContact_Typesdata(state, value) {
      state.allcontact_Typesdata = value;
    },
    change_contact(state, value) {
      state.current_contact = value;
    },
    changeLoading(state, value) {
      state.loading = value;
    },
    setAllConversations(state, newState) {
      state.allConversations = newState;
    },
    unshiftAllConversations(state, newState) {
      state.allConversations.unshift(...newState);
    },
    appendAllConversations(state, newState){
      state.allConversations.push(...newState);
    },
    updateContactDetails(state,newState) {
      let elementIndex = [];
      let ph1, ph2, ph3;
      ph1 = newState[0].ph1;
      if (newState[0].ph1.length > 10) {
        ph1 = newState[0].ph1.substring(newState[0].ph1.length - 10);
      }
      ph2 = newState[0].ph2;
      if (newState[0].ph2?.length > 10) {
        ph2 = newState[0].ph2.substring(newState[0].ph2.length - 10);
      }
      ph3 = newState[0].ph3;
      if (newState[0].ph3?.length > 10) {
        ph3 = newState[0].ph3.substring(newState[0].ph3.length - 10);
      }
      for (let i = 0; i < state.left_panel_contacts.length ; i++) {
        let callObject = state.left_panel_contacts[i]
        if(callObject.contact_id == newState[0].contact_id){
          callObject.first_name=newState[0].first_name;
          callObject.last_name=newState[0].last_name;
          callObject.ph1=newState[0].ph1;
          callObject.ph2=newState[0].ph2;
          callObject.ph3=newState[0].ph3;
          callObject.email = newState[0].email;
          callObject.textable1=newState[0].textable1;
          callObject.textable2=newState[0].textable2;
          callObject.textable3=newState[0].textable3;
          elementIndex.push(i);
        }else if(callObject.contact_id==newState[0].ph1 ||callObject.contact_id==ph1 ||callObject.contact_id==ph2 ||callObject.contact_id==ph3 ||callObject.contact_id==newState[0].ph2 || callObject.contact_id==newState[0].ph3 ){
          callObject.contact_id=newState[0].contact_id;
          callObject.first_name=newState[0].first_name;
          callObject.last_name=newState[0].last_name;
          callObject.ph1=newState[0].ph1;
          callObject.ph2=newState[0].ph2;
          callObject.ph3=newState[0].ph3;
          callObject.email = newState[0].email;
          callObject.textable1=newState[0].textable1;
          callObject.textable2=newState[0].textable2;
          callObject.textable3=newState[0].textable3;
          callObject.phone_num="";
          elementIndex.push(i);
        }
      }
      console.log(" the elementindex is:" + elementIndex);
      if (elementIndex.length > 1) {
        for (let i = elementIndex.length - 1; i != 0; i--) {
          console.log(
            "removing element at index" +
              elementIndex[i] +
              " the location of i" +
              i
          );
          state.left_panel_contacts.splice(elementIndex[i], 1);
        }
      }
      return state.left_panel_contacts;
    },
addNewCall(state, newState) {
  if (!Array.isArray(newState) || !newState.length) return;

  const newEntry = newState[0];
  if (!newEntry?.contact_id) return;

  const index = state.fd_contacts.findIndex(
    c => c.contact_id === newEntry.contact_id
  );

  if (index !== -1) {
    state.fd_contacts.splice(index, 1);
  }

  state.fd_contacts.unshift(newEntry);
},

// A conversation reminder just became due (reminder-due-sync, pushed via the
// "reminderDue" websocket message) — surface the contact at the top of the live
// left-panel list with a due badge. Mirrors addNewCall's find-and-unshift pattern,
// but merges onto any already-loaded entry first so fields the push payload doesn't
// carry (email, tag_id, etc.) aren't clobbered.
reminderDue(state, newState) {
  if (!Array.isArray(newState) || !newState.length) return;

  const pushed = newState[0];
  if (!pushed?.contact_id) return;

  const index = state.fd_contacts.findIndex(
    c => c.contact_id === pushed.contact_id
  );

  const existing = index !== -1 ? state.fd_contacts[index] : null;
  const newEntry = { ...existing, ...pushed, is_reminder_due: true };

  if (index !== -1) {
    state.fd_contacts.splice(index, 1);
  }

  state.fd_contacts.unshift(newEntry);
},

// A reminder that had previously fired (and put up the is_reminder_due badge)
// has now been fully resolved for this contact — every convo_reminder that
// bridges to it is either rescheduled or removed (backend only broadcasts
// this once its own aggregate check confirms none remain due). Clear the
// badge but leave the contact/row itself in place.
reminderResolved(state, payload) {
  const contactId = payload?.contact_id;
  if (!contactId) return;

  const index = state.fd_contacts.findIndex(c => c.contact_id === contactId);
  if (index === -1) return;

  const newEntry = { ...state.fd_contacts[index], is_reminder_due: false, reminder_date: null };
  state.fd_contacts.splice(index, 1, newEntry);
},

// Live tag add/remove pushed via the "addConversationTag"/"removeConversationTag"
// websocket messages (tag.controller.js) — keeps the currently-open central
// panel's tag chips in sync with tagging done by another staff member (or the
// reminder-due-sync auto-tag), mirroring FDMessage.vue's own local
// applyTag/removeTag in-place mutation of `message.tags`.
addConversationTagLive(state, payload) {
  const { conversation_id, tag_id } = payload || {};
  if (conversation_id == null || tag_id == null) return;

  const message = state.allConversations.find(
    m => m.comm_participant_id === conversation_id
  );
  if (!message) return;

  if (!Array.isArray(message.tags)) message.tags = [];
  if (!message.tags.includes(tag_id)) message.tags.push(tag_id);
},

removeConversationTagLive(state, payload) {
  const { conversation_id, tag_id } = payload || {};
  if (conversation_id == null || tag_id == null) return;

  const message = state.allConversations.find(
    m => m.comm_participant_id === conversation_id
  );
  if (!message || !Array.isArray(message.tags)) return;

  const idx = message.tags.indexOf(tag_id);
  if (idx !== -1) message.tags.splice(idx, 1);
},

// Keeps the "Unattended" filter view (left_panel_contacts) live, without a
// follow-up fetch — socketPlugin.js only commits these once it's confirmed
// tag_id is the client's "Unattended" tag. left_panel_contacts and
// fd_contacts share the same row shape (both built by merging a base row
// with people/contactsHash — see retrieveCalls/getconversationtag), so an
// already-loaded fd_contacts entry can be reused directly here.
unattendedTagAddedLive(state, payload) {
  const { contact_id, first_name, last_name, ph1 } = payload || {};
  if (contact_id == null) return;
  if (state.left_panel_contacts.some(c => c.contact_id === contact_id)) return;

  // Prefer an already-loaded fd_contacts row when available — it carries
  // richer fields (ph2/ph3/email/etc.) than the broadcast payload does. But
  // the tagged contact is frequently *not* loaded there (e.g. an older
  // conversation with no other recent activity, like a message from weeks
  // ago suddenly getting a reminder) — in that case, fall back to the
  // name/phone tag.controller.js's addTagForConversation already included in
  // the payload for exactly this reason, rather than silently skipping.
  const source = state.fd_contacts.find(c => c.contact_id === contact_id);
  const row = source
    ? { ...source, isContact: true }
    : { contact_id, first_name, last_name, ph1, isContact: true };

  state.left_panel_contacts.unshift(row);
},

unattendedTagRemovedLive(state, payload) {
  const { contact_id, contact_still_tagged } = payload || {};
  // contact_still_tagged: another of this contact's conversations still
  // carries the tag (computed server-side, tag.controller.js) — don't drop
  // them from the filtered view just because this one conversation resolved.
  if (contact_id == null || contact_still_tagged) return;

  const index = state.left_panel_contacts.findIndex(c => c.contact_id === contact_id);
  if (index !== -1) state.left_panel_contacts.splice(index, 1);
},

    callDetails(state, newState) {
      let selectedContactId = state.current_contact.contact_id
      if(selectedContactId == newState[0].contact_id) {
        let newEntry = newState[0]
        if(newState[0].call_id){ // call case
          let index = state.allConversations.findIndex(n => n.call_id === newState[0].call_id);
          if(index !== -1){
            state.allConversations.splice(index,1,newEntry);
          }else{
            state.allConversations.push(newEntry)
            state.allcontact_Typesdata[newEntry.typeName].push(newEntry);
          }
        }else{
          //text message case
          state.allConversations.push(newEntry)
	        if (newEntry.typeName && state.allcontact_Typesdata[newEntry.typeName]) {
	          state.allcontact_Typesdata[newEntry.typeName].push(newEntry);
	        }
        }

        // Tag-removal captions are synthetic background annotations on an
        // existing message, not a new message the user needs scrolled into
        // view — forcing scroll-bottom for them races the DynamicScroller's
        // async height recalculation for the now-taller tagged message and
        // mispositions everything below it until a full remount.
        if (!(newEntry.is_system_message && newEntry.ref_conversation_id)) {
          EventBus.$emit("scroll-bottom");
        }
	    }
      return state.allConversations
    },
    thread(state, newThread) {
      state.thread = newThread;
    },
    emails(state, newEmails) {
      state.emails = newEmails;
    },
    toggleThreadVisibility(state) {
      state.threadVisibility = !state.threadVisibility;
    },
    set_odData(state, newState) {
      state.odData = newState;
      if (!newState) {
        state.odDataHash = {};
      }
    },
    updateLabStatus(state, { contactId, labNum, newStatus }) {
    const contact = state.odData.find(c => c.contact_id === contactId);
    if (!contact || !Array.isArray(contact.od_json)) return;
    contact.od_json = contact.od_json.map(item => {
      if (item.Lab_Num === labNum) {
        return { ...item, status: newStatus };
      }
      return item;
    });
  },
    labdata(state, value){
      state.labmoredata = value;
    },
    setlaboffset(state ,value){
        state.laboffset = value;
    },
    set_odDataHash(state, newState) {
      state.odDataHash = newState;
    },
    append_odData(state, newState) {
      state.odData.push(...newState);
    },
    append_odDataHash(state, newState) {
      state.odDataHash = { ...state.odDataHash, ...newState };
    },
    odSelected_value(state, newState) {
      state.odSelected_value = newState;
    },
    setOdTag(state, newState) {
      state.selected_OD_tag = newState;
    },
    set_right_panel_tab(state, newState) {
      state.right_panel_tab = newState;
    },
    isUser(state, newState) {
      state.isUser = newState;
    },
    update_convo_count(state, data) {
      let ind = state.allConversations.findIndex(
        (c) => c.comm_participant_id === data.conversation_id
      );
      if (ind !== -1) {
        state.allConversations[ind].internal_convo_count += data.count;
      }
    },
    set_message_templates(state, newState) {
      state.message_templates = newState;
    },
    add_message_template(state, newState) {
      state.message_templates.push(newState);
    },
    update_message_template(state, newState) {
      let ind = state.message_templates.findIndex(
        (c) => c.template_id === newState.template_id
      );
      if (ind !== -1) {
        state.message_templates.splice(ind, 1, newState);
      }
    },
    delete_message_template(state, newState) {
      let ind = state.message_templates.findIndex(
        (t) => t.template_id === Number(newState.template_id)
      );
      if (ind !== -1) {
        state.message_templates.splice(ind, 1);
      }
    },
    conversation_loading(state,newState){
      state.conversation_loading = newState;
    },
    updateIsScrollerVisible(state,newState){
      state.isScrollerVisible = newState;
    },
    updateIsFilterApplied(state, newState){
      state.isFilterApplied = newState;
    },
    setOdFilterList(state, filters) {
      state.odFilterList = filters;
    }
  },
  actions: {
    async loadOdFilters({ commit }) {
      try {
        const res = await OdService.getOdFilters();
        const filters = res?.data?.data || [];
        commit('setOdFilterList', filters);
      } catch (err) {
        console.error('Failed to load OD filters:', err);
      }
    },

    async retrieveCalls({ state , commit, getters, rootGetters }) {
      try {
        if(state.isFilterApplied) return;
        const res = await MiscService.getCalls();
        const contactsHash = rootGetters["people/contactsHash"];

        let calls = res.data.map((c) => {
          if (c == null) {
            console.log("We have a null entry");
            return null; // Return null or handle as needed
          }

          if (c.isContact) {
            const contact = contactsHash[c.contact_id];
            if (contact) {
              return {
                ...c,
                ph1: contact.ph1,
                ph2: contact.ph2,
                ph3: contact.ph3,
                textable1: contact.textable1,
                textable2: contact.textable2,
                textable3: contact.textable3,
                contact_type: contact.contact_type,
                email: contact?.email,
                contact_id: contact.contact_id,
                tag_id: contact.tags,
                family: contact.family,
              };
            }
            //  c["tag_id"] = tagContactHash[c.contact_id]
          } else {
            return {
              ...c,
              phone_num: c.contact_id,
            };
          }
          return c; // Default return
        });

        const typeHash = rootGetters["people/contactTypes"];
        const tagsHash = rootGetters["tags/tagsHash"];

        let mapper = {};
        let allcontact_Typesdata = {};
        let alltags_data = {};

        Object.values(tagsHash).forEach((value) => {
          alltags_data[value] = [];
        });
       
        for (let type of typeHash) {
          mapper[type.type_id] = type.type_name;
          allcontact_Typesdata[type.type_name] = [];
        }

       

        for (let call of calls) {
          let type = call?.contact_type;
          let typename = mapper[type];
          if (!allcontact_Typesdata[typename]) {
            allcontact_Typesdata[typename] = [];
          }
          allcontact_Typesdata[typename].push(call);

          if (call.tag_id) {
            for (let t_id of call.tag_id) {
              if (!alltags_data[tagsHash[t_id]]) {
                alltags_data[tagsHash[t_id]] = [];
              }
              alltags_data[tagsHash[t_id]].push(call);
            }
          }
        }

        commit("set_AllContact_Typesdata", allcontact_Typesdata);
        commit("set_alltags_data", alltags_data);

        commit("set_left_panel_contacts", calls);
        commit("fd_contacts", calls);

        // now we must update call because the corresponding call in calls may have changed
        if (getters.current_contact.call_id)
          commit(
            "change_contact",
            getters.left_panel_contacts.find(
              (e) => e.call_id === getters.current_contact.call_id
            ) || {}
          );
        commit("changeLoading", false);
      } catch (err) {
        commit("changeLoading", false);
        throw new Error(err);
      }
    },
    async retrieveEmails({ commit}, threadId) {
      try {
        console.log("threadId = ", threadId);
        commit("thread", threadId);
        let res = await MiscService.getEmailsForThread(threadId);
        console.log("Service called, res = ", res.data);
        commit("emails", res.data);
      } catch (err) {
        console.error(err);
      }
    },
    async hideThreads({ commit, getters, rootGetters }) {
      commit("thread", null);
      if(getters.getThreadVisibility) {
      commit("toggleThreadVisibility");
      }
      commit("emails", []);
    },
    // get contacts from OD based on the type
  async getODdata({ state,dispatch,  commit, rootGetters }, { filterName, isLoadMore = false } = {})  {
  const payload = filterName;
  let offset = 0;
  let res;

  // isLoadMore is only true for scroll-triggered pagination (handleScroll). Any other
  // call (fresh selection, re-clicking an already-active filter, initial load) always
  // does a full replace at offset 0 — relying on payload === state.odSelected_value
  // here was ambiguous, since re-clicking an active filter matched the same condition
  // as a scroll continuation and could silently no-op or append onto stale data.
  if (isLoadMore) {
    let dataLength = Object.keys(state.odData).length;

    if (dataLength && dataLength % 100 === 0 && payload !== 'lab-cases') {
      offset = dataLength;
    }else if (payload === 'lab-cases' && state.labmoredata) {
      if (state.laboffset) {
        offset = state.laboffset;
      }else{
        return;
      }
    }else if(payload === 'Unscheduled' && state.laboffset % 100 === 0){
    if (state.laboffset) {
            offset = state.laboffset;
          }else{
            return;
          }
        } else {
          return;
        }
  }
   // Test Data
    //   let res ={data : [ {
    //     call_status: null,
    //     comm_direction: null,
    //     contact_id: 102083,
    //     date: "2024-04-01 00:00:00",
    //     date1: "04/18/2024",
    //     first_name: "Surya",
    //     isContact: true,
    //     last_name: "Dev",
    //     seqId: "102083_1",
    //     sortField: "2024-04-01T00:00:00.000Z"
    // }]};

  commit("changeLoading", true);

  try {
    // Resolve filter definition from dynamically loaded list
    const filterDef = state.odFilterList.find(f => f.filter_name === payload);
    if (!filterDef) {
      commit("changeLoading", false);
      return;
    }

    if (filterDef.execution_mode === 'labcases_api') {
      // lab-cases has complex pagination handled via its dedicated endpoint
      res = await OdService.getlabcases({ offset });
      console.log(offset, "lab-cases Res:", res);
    } else {
      // All other filters (sql + recalls_api) go through the generic execute endpoint
      if (payload === 'Pre-Auths') {
        await dispatch('osclaims/retrieveClaims', "osclaims", { root: true });
      }
      res = await OdService.executeOdFilter(filterDef.id, offset);
      console.log(offset, `${payload} Res:`, res);
    }
   const all_data = res?.data?.data || res?.data || [];

const reslength = all_data.length;
    if (reslength > 0) {
      const contactsHash = rootGetters["people/contactsHash"];
      let od_contacts = [];
      let od_contactsHash = {};

      console.log(`Current count: ${reslength}`);


      for (let i = 0; i < reslength; i++) {
        const c = all_data[i];
        if (!c) continue; // Skip null values

        let call = {};

        if (c.isContact) {
          const contact = contactsHash[c.contact_id] || {};
          Object.assign(call, {
            ...c,
            call_status: -1,
            comm_direction: -1,
            contact_id: contact?.contact_id,
            ph1: contact?.ph1,
            ph2: contact?.ph2,
            ph3: contact?.ph3,
            email: contact?.email,
            textable1: contact?.textable1,
            textable2: contact?.textable2,
            textable3: contact?.textable3,
            contact_type: contact?.contact_type,
            tag_id: contact?.tags,
            family: contact.family,
          });
        } else {
          call.phone_num = c.contact_id;
        }

      //merge data when payload === "lab-cases" — only across pages of the SAME
      // fetch (isLoadMore); on a fresh load this must not consult stale
      // odDataHash/odData left over from whatever was loaded before, or rows
      // that happen to share a contact_id with old data get silently merged
      // away instead of added, undercounting the fresh result.
      if (isLoadMore && (payload === "lab-cases" || payload === "Unscheduled") && state.odDataHash && state.odDataHash[c.contact_id]) {
        const existing = state.odData.find(d => d.contact_id === c.contact_id);
        if (existing) {
          // merge od_json
          if (Array.isArray(existing.od_json) && Array.isArray(c.od_json)) {
            existing.od_json = [...existing.od_json, ...c.od_json];
          } else if (c.od_json) {
            existing.od_json = c.od_json;
          } else {
            console.log(` No od_json to merge for contact_id=${c.contact_id}`);
          }
        }
      } else {
        od_contactsHash[c.contact_id] = true;
        od_contacts.push(call);
      }
      }

      // Update state
      if (isLoadMore) {
        commit("append_odData", od_contacts);
        commit("append_odDataHash", od_contactsHash);
      } else {
        state.odSelected_value = payload;
        commit("set_odData", od_contacts);
        commit("set_odDataHash", od_contactsHash);
      }

      // Special pagination handling for lab-cases
      if (payload === "lab-cases") {
        if(res?.data?.offset){
          commit("setlaboffset",res.data.offset);
        }
          if (res?.data?.hasMore) {
          commit("labdata", true);
          } else {
          commit("labdata", false);
            console.log(" No more lab-cases data. Stopping.");
          }
      }else if(payload == "Unscheduled" && res.data?.offset){
        commit("setlaboffset",res.data.offset);
       }
    } else {
        if (payload === "lab-cases") {
        if (res?.data?.offset !== undefined) {
          commit("setlaboffset", res.data.offset);
        }
        if (res?.data?.hasMore) {
          commit("labdata", true);
        } else {
          commit("labdata", false);
        }
    } else {
         commit("set_odData", []);
        commit("set_odDataHash", {});
      }
    }
  } catch (error) {
    console.log(error);
    commit("set_odData", []);
    commit("append_odDataHash", {});
    commit("changeLoading", false);
  }

  commit("changeLoading", false);
},
async getconversationtag({ state, commit, rootGetters }, payload) {
  try {
    const { tag_id, reset = false } = payload;

    if (reset) {
      commit("set_odData", []);
      commit("set_odDataHash", {});
      commit("setOdHasMore", true);
      commit("setshowconversationtagarrow", false);
      commit("SetConversationTagOffset",0);
    }

    if (!state.odHasMore) return;

    const offset = state.conversationtagoffset;
    commit("changeLoading", true);

    const res = await MiscService.getConversationTagContacts(tag_id, offset);
    const data = res?.data?.data || [];
    const pagination = res?.data?.pagination || {};

    if (!Array.isArray(data) || data.length === 0) {
      commit("setOdHasMore", false);
      return;
    }

    const contactsHash = rootGetters["people/contactsHash"];
    let newContacts = [];
    let newHash = {};

    for (const row of data) {
      if (!row?.contact_id) continue;

      // Prevent duplicates
      if (state.odDataHash[row.contact_id]) continue;

      const contact = contactsHash[row.contact_id] || {};

      const mapped = {
        ...row,
        contact_id: contact.contact_id || row.contact_id,
        ph1: contact.ph1,
        ph2: contact.ph2,
        ph3: contact.ph3,
        email: contact.email,
        textable1: contact.textable1,
        textable2: contact.textable2,
        textable3: contact.textable3,
        contact_type: contact.contact_type,
        tag_id: contact.tags,
        family: contact.family,
      };

      newContacts.push(mapped);
      newHash[mapped.contact_id] = true;
    }

    if (newContacts.length) {
      
      commit("append_odData", newContacts);
      commit("append_odDataHash", newHash);
      commit("setshowconversationtagarrow", true);
    }
      commit("SetConversationTagOffset",pagination.offset);
    if (pagination.hasMore === false) {
      commit("setOdHasMore", false);
    }

  } catch (err) {
    console.error("getconversationtag error", err);
  } finally {
    commit("changeLoading", false);
  }
},

  // Updating allcontact_Typesdata while contact type changing in left panel
  update_contactTypesdata({ state, rootGetters }, payload) {

    let contact = null;

      for (const key of Object.keys(state.allcontact_Typesdata)) {
        const contactsArray = state.allcontact_Typesdata[key];
        const index = contactsArray.findIndex(
          (contact) => contact.contact_id === payload.contact_id
        );

        if (index !== -1) {
          [contact] = contactsArray.splice(index, 1);
          break;
        }
      }
      const typeHash = rootGetters["people/contactTypes"];
      const typeEntry = typeHash.find(
        (type) => payload.contact_type === type.type_id
      );
      const typeName = typeEntry.type_name;

      if (!state.allcontact_Typesdata[typeName]) {
        state.allcontact_Typesdata[typeName] = [];
      }

      // add the contact to the new type
      state.allcontact_Typesdata[typeName].push(contact);
    },
    add_contactTagsdata({ state, getters, rootGetters }, payload) {
      try {
        const tagsHash = rootGetters["tags/tagsHash"];
        const contact_id = payload.contact_id;
        const tag_id = payload.tag_id;

        let ind = getters.left_panel_contacts.findIndex(
          (e) => e.contact_id === Number(contact_id)
        );
        const contact = state.left_panel_contacts[ind];

        // for left panel tag ui
        if (state.left_panel_contacts[ind].tag_id) {
          state.left_panel_contacts[ind].tag_id.push(payload.tag_id);
        } else {
          state.left_panel_contacts[ind].tag_id = [];
          state.left_panel_contacts[ind].tag_id.push(payload.tag_id);
        }

        //for filter
        if (state.alltags_data[tagsHash[tag_id]]) {
          state.alltags_data[tagsHash[tag_id]].push(contact);
        } else {
          state.alltags_data[tagsHash[tag_id]] = [];
          state.alltags_data[tagsHash[tag_id]].push(contact);
        }
      } catch (error) {
        console.log(error);
      }
    },
    remove_contactTagsdata({ state, getters, rootGetters }, payload) {
      try {
        const tagsHash = rootGetters["tags/tagsHash"];
        const contact_id = payload.contact_id;

        let ind = getters.left_panel_contacts.findIndex(
          (e) => e.contact_id === Number(contact_id)
        );
        const contact = getters.left_panel_contacts[ind];

        // for left panel tag ui — mutate in place (matching
        // add_contactTagsdata's push) so people/contactsHash[...].tags,
        // which shares this same array reference, sees the removal too.
        const tagIds = state.left_panel_contacts[ind].tag_id;
        if (tagIds) {
          const idx = tagIds.indexOf(payload.tag_id);
          if (idx !== -1) tagIds.splice(idx, 1);
        }
        // if it is current contact
        if (payload.contact_id == state.current_contact.contact_id) {
          state.current_contact.tag_id = state.left_panel_contacts[ind].tag_id;
        }
        //for filter
        let index =
          state.alltags_data[tagsHash[payload.tag_id]].indexOf(contact);
        state.alltags_data[tagsHash[payload.tag_id]].splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    async getMessageTemplates({ commit }) {
      try {
        let res = await MiscService.getMessageTemplates();
        commit("set_message_templates", res.data);
      } catch (error) {
        console.error(error);
      }
    },
    async createMessageTemplate({ commit }, payload) {
      try {
        let res = await MiscService.createMessageTemplate(payload);
        if (res.status === 201) {
          EventBus.$emit("alert", {
            message: "Message Template Created Successfully",
            type: ALERT.SUCCESS,
          });
        }
      } catch (error) {
        EventBus.$emit("alert", {
          message: "Failed To Created Message Template",
          type: ALERT.ERROR,
        });
        console.error(error);
      }
    },
    async updateMessageTemplate({ commit }, payload) {
      try {
        let res = await MiscService.updateMessageTemplate(
          payload.template_id,
          payload.data
        );
        if (res.status === 200) {
          EventBus.$emit("alert", {
            message: "Message Template Updated Successfully",
            type: ALERT.SUCCESS,
          });
        }
      } catch (error) {
        EventBus.$emit("alert", {
          message: "Failed To Update Message Template",
          type: ALERT.ERROR,
        });
        console.error(error);
      }
    },
    async deleteMessageTemplate({ commit }, payload) {
      try {
        let res = await MiscService.deleteMessageTemplate(payload);
        if (res.status === 200) {
          EventBus.$emit("alert", {
            message: "Message Template Deleted Successfully",
            type: ALERT.SUCCESS,
          });
        }
      } catch (error) {
        EventBus.$emit("alert", {
          message: "Failed To Deleted Message Template",
          type: ALERT.ERROR,
        });
        console.error(error);
      }
    },
  async getConversations({ state, commit, getters }, payload){
  try {

    if(getters.getAllConversations?.length && state.previousContactId === payload){
        return;
    }
     let conversation = [];
     let res;
     const id = payload?.contact_id || payload.memberIds;
     let direction = payload?.direction || GET_CONVERSATIONS.GREATERTHAN;
     let offset = payload?.offset || 0;
     let limit = getters.dynamicMessageThreshold; // dynamic message threshold based on screen height
     state.hasMoreConversatonTop = true;
      if(direction === GET_CONVERSATIONS.LESSTHAN_EQUAL){
        state.hasMoreConversatonBottom = true; // when searching conversation we can assume there are more conversations to load from bottom
      }

      commit("conversation_loading", true);
      state.previousContactId = id;
      state.isScrollerVisible = false;
      commit("setAllConversations",[]);
    
      if(state.isUser){
        res = await MiscService.getAllUserConversations(id, offset, limit, direction);
      }else if(state.current_contact.contact_id === 'family'){
        state.previousContactId = 'family';
        res  = await MiscService.getFamilyMembersConversations({memberIds : id}, offset, limit, direction);
      }else{
        res = await MiscService.getConversationsForContact(id, offset, limit, direction);
      }
      
       conversation.push(...res.data.commData);
       if(res.data.id === state.current_contact.contact_id){
        commit("setAllConversations",conversation); // to avoid old pending response messages setting to current contact
       }
       commit("conversation_loading", false);
      if(res.data.commData?.length === 0){ 
        console.log("No conversations found for this contact");
        
        state.hasMoreConversatonTop = false;
        state.hasMoreConversatonBottom = false;
      }
  } catch (error) {
     commit("conversation_loading", false);
     console.error(error);
     
  }
  },
  async getMoreConversations({ state, commit, getters }, payload){
    try {
      if(state.previousContactId !== getters.current_contact.contact_id || getters.conversation_loading){
        return;
      }
      let data;
      let direction = payload.direction;
      let offset = payload.offset;
      let limit = getters.dynamicMessageThreshold; // dynamic message threshold based on screen height
      commit("conversation_loading", true);

      if (state.isUser) {
        let res  = await MiscService.getAllUserConversations(getters.current_contact.contact_id, offset, limit, direction );
        data = res.data;
      }else if(state.current_contact.contact_id === 'family'){
        let res  = await MiscService.getFamilyMembersConversations({memberIds: getters.current_contact.memberIds}, offset, limit, direction );
        data = res.data;
      }else {
        let res  = await MiscService.getConversationsForContact(getters.current_contact.contact_id, offset, limit, direction );
        data = res.data;
      }
           
      if (data.commData.length !== 0 && data.id === state.current_contact.contact_id) {
        if(direction === GET_CONVERSATIONS.LESSTHAN){
            commit("unshiftAllConversations", data.commData);
        }else if(direction === GET_CONVERSATIONS.GREATERTHAN){
            commit("appendAllConversations", data.commData);
        }

      }

      if(data.commData.length === 0){
        if(direction === GET_CONVERSATIONS.GREATERTHAN){
          state.hasMoreConversatonBottom = false; // No more data to load from bottom
          console.log("No more data to load from bottom");
        }else if(direction === GET_CONVERSATIONS.LESSTHAN){
          state.hasMoreConversatonTop = false; // No more data to load from top
          console.log("No more data to load from top");
        }
      }

      commit("conversation_loading", false);
    } catch (error) {
      console.error(error);
      commit("conversation_loading", false);
    }
  },
  async searchConversation({dispatch}, payload){
    try {
      let contact_id = payload.contact_id;
      let offset = payload.timestamp;
      await dispatch("getConversations",{contact_id : contact_id, offset : offset, direction : GET_CONVERSATIONS.LESSTHAN_EQUAL});
      await dispatch("getMoreConversationsBottom");
    } catch (error) {
      console.error(error);
    }
  },
  async getMoreConversationsTop({dispatch, getters}){
    try {
      if(!getters.hasMoreConversatonTop){
        return;
      }
      // Tag-removal system-message captions carry the removal's own
      // timestamp (whenever the tag was actually removed), not the
      // referenced message's chronological position, so they can sort to
      // either end of a page regardless of that page's real time window.
      // Anchor pagination on the first REAL message, not a caption, or a
      // stray caption's timestamp silently truncates the conversation.
      const firstReal = getters.getAllConversations.find(c => !c.is_system_message);
      if (!firstReal) return;
      let payload = {
        offset : firstReal.timestamp,
        direction : GET_CONVERSATIONS.LESSTHAN
      }
      await dispatch("getMoreConversations",payload);
    } catch (error) {
      console.error(error);
    }
  },
  async getMoreConversationsBottom({dispatch, getters}){
    try {
      if(!getters.hasMoreConversatonBottom){
        return;
      }
      // See getMoreConversationsTop — same reasoning, last REAL message.
      const list = getters.getAllConversations;
      let lastReal;
      for (let i = list.length - 1; i >= 0; i--) {
        if (!list[i].is_system_message) { lastReal = list[i]; break; }
      }
      if (!lastReal) return;
      let payload = {
        offset : lastReal.timestamp,
        direction : GET_CONVERSATIONS.GREATERTHAN
      }
      await dispatch("getMoreConversations",payload);
    } catch (error) {
      console.error(error);
    }
  },
  }
};

